// Import stores needed for custom hooks
import { useAuthStore } from './authStore';
import { useDataStore } from './dataStore';
import { useUIStore } from './uiStore';

// Export all stores
export { useAuthStore } from './authStore';
export { useDataStore } from './dataStore';
export { useUIStore } from './uiStore';
export { useClientAuthStore } from './clientAuthStore';
export { useEmployeeAuthStore } from './employeeAuthStore';

/**
 * Custom hook to get authentication status
 */
export const useAuth = () => {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const user = useAuthStore(state => state.user);
  const login = useAuthStore(state => state.login);
  const logout = useAuthStore(state => state.logout);
  const initialize = useAuthStore(state => state.initialize);
  const isLoading = useAuthStore(state => state.isLoading);
  const error = useAuthStore(state => state.error);
  
  return {
    isAuthenticated,
    user,
    login,
    logout,
    initialize,
    isLoading,
    error
  };
};

/**
 * Custom hook to get dashboard data
 * Uses a single selector to prevent excessive re-renders
 */
export const useDashboard = () => {
  return useDataStore(state => {
    const ongoingProjects = state.projects.filter(p => p.status === 'ongoing');
    const completedProjects = state.projects.filter(p => p.status === 'completed');
    const pendingContacts = state.contacts.filter(c => c.status === 'pending');
    
    return {
      stats: state.stats,
      projects: state.projects,
      contacts: state.contacts,
      ongoingProjects,
      completedProjects,
      pendingContacts,
      isLoading: state.isLoading,
      isRefreshing: state.isRefreshing,
      lastRefresh: state.lastRefresh,
      error: state.error
    };
  });
};

/**
 * Custom hook for notifications
 */
export const useNotifications = () => {
  const notifications = useUIStore(state => state.notifications);
  const addNotification = useUIStore(state => state.addNotification);
  const removeNotification = useUIStore(state => state.removeNotification);
  const clearNotifications = useUIStore(state => state.clearNotifications);
  const showSuccessNotification = useUIStore(state => state.showSuccessNotification);
  const showErrorNotification = useUIStore(state => state.showErrorNotification);
  const showInfoNotification = useUIStore(state => state.showInfoNotification);
  const showWarningNotification = useUIStore(state => state.showWarningNotification);
  
  return {
    notifications,
    addNotification,
    removeNotification,
    clearNotifications,
    showSuccessNotification,
    showErrorNotification,
    showInfoNotification,
    showWarningNotification
  };
};